import React, { FunctionComponent, memo } from 'react'

import { BusinessContactTableItem } from '../../utils/useBusinessContactData'
import { BusinessContactNoteEdit } from '../BusinessContactNoteEdit/BusinessContactNoteEdit'

export interface BusinessContactTableActionProps {
  record: BusinessContactTableItem
  onUpdate?: () => void
}

export const BusinessContactTableAction: FunctionComponent<BusinessContactTableActionProps> =
  memo(({ record, onUpdate }) => {
    return (
      <div className="space-y-1">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1">
            {record.note ? (
              <div>{record.note}</div>
            ) : (
              <div className="text-gray-400">---</div>
            )}
          </div>
          <div className="flex space-x-2">
            <BusinessContactNoteEdit record={record} onUpdate={onUpdate} />
          </div>
        </div>
      </div>
    )
  })
